import { createI18n } from 'vue-i18n'

const messages = {
  kr: {
    common: {
        confirm: '확인',
        cancel: '취소',
        close: '닫기',
        loading: '로딩 중...',
        processing: '처리 중...',
        success: '성공',
        failed: '실패',
        retry: '다시 시도',
        copy: '복사',
        copied: '복사됨!',
        refresh: '새로 고침',
        viewAll: '전체 보기',
        noData: '데이터 없음',
        submit: '제출',
        save: '저장',
        edit: '편집',
        delete: '삭제',
        search: '검색',
        query: '조회',
        comingSoon: '출시 예정',
        back: '뒤로',
        next: '다음',
        yes: '예',
        no: '아니요',
    },

    nav: {
        home: '홈',
        dashboard: '플레이어 라운드',
        tai: '생태계',
        prediction: '예측',
        nodes: '노드',
        community: '커뮤니티',
        swap: '스왑',
        admin: '관리자',
    },
    referrer: {
        title: '추천인 주소 입력',
        subtitle: '추천인 지갑 주소를 입력하세요',
        address: '추천인 주소',
        placeholder: '추천인 지갑 주소 입력 (0x...)',
        hint: '유효한 이더리움 주소를 입력하세요',
        confirm: '확인',
        required: '추천인 필요',
        description: '등록을 위해 유효한 추천인 주소가 필요합니다',
        errorEmpty: '추천인 주소는 필수입니다',
        errorInvalid: '잘못된 주소 형식입니다',
        errorZero: '잘못된 주소: 제로 주소는 사용할 수 없습니다',
    },

    wallet: {
        referrerAddress: '추천인 주소',
        enterReferrer: '추천인 지갑 주소 입력',
        referrerRequired: '추천인 주소는 필수입니다',
        invalidAddress: '잘못된 주소 형식입니다',
        connect: '지갑 연결',
        disconnect: '연결 해제',
        connecting: '연결 중...',
        connected: '연결됨',
        title: '지갑 연결',
        subtitle: '계속하려면 Web3 지갑을 선택하세요',
        detected: '감지됨 · 준비됨',
        notInstalled: '설치되지 않음',
        secure: '안전 · 비수탁형',
        terms: '연결하면 서명을 통해 지갑 소유권을 확인합니다. 개인 키는 절대 공유되지 않습니다.',
        rejected: '사용자가 연결을 거부했습니다',
        signRequired: '지갑 소유권 확인을 위해 메시지에 서명해주세요',
        networkError: 'BSC 네트워크로 전환 후 다시 시도해주세요',
        failed: '연결 실패, 다시 시도해주세요',
        noWallet: '지갑이 감지되지 않았습니다. Web3 지갑을 설치하세요.',
        installPrompt: '설치',
        switchNetwork: 'BSC로 전환',
        ready: '준비됨',
    },

    home: {
        tagline: 'BSC에서 활성화',
        heroTitle1: 'User Keep',
        heroTitle2: 'UK 토큰',
        heroDesc: '스테이킹 · 예측 · 수익 · 성장\nNEXA PAY 글로벌 결제 네트워크 기반',
        connectStart: '지갑 연결하여 시작',
        goDashboard: '플레이어 라운드로 이동',
        tradeUK: 'UK 거래',
        currentPrice: '현재 가격',
        priceMultiple: '가격 배수',
        totalSupply: '총 공급량',
        activeNodes: '활성 노드',
        feature1Title: '예측 스테이킹',
        feature1Desc: '100–1000 USDT 스테이킹, 10x/30x/100x 목표 설정. 목표 가격 도달 시 자동 강제 매도.',
        feature2Title: '커뮤니티 보상',
        feature2Desc: '팀을 구축하고 매일 보상 풀에서 V1–V7 커뮤니티 인센티브를 획득하세요.',
        feature3Title: '노드 특권',
        feature3Desc: '600 USDT로 노드 구매, 1000 UK 획득, 스왑 슬리피지 배당, DAO 투표권.',
    },

    dashboard: {
        withdrawSuccess: "인출 성공",
        insufficientBalance: "잔액 부족",
        max: "최대",
        rewardDetails: "보상 내역",
        noRewards: "아직 보상 기록이 없습니다",
        nodeReward: "노드 보상",
        nodeRewardDesc: "출시된 노드 UK 보상",
        liquidityRewardDesc: "일일 유동성 풀 보상 (10%)",
        communityRewardDesc: "커뮤니티 레벨 보상 (40%)",
        nodeDividendDesc: "예측 메커니즘 노드 배당 (5%) + 매매 메커니즘 노드 배당 (5%)",
        claimed: "수령 완료",
        total: "합계",
        view: '보기',
        title: '플레이어 라운드',
        subtitle: '자산, 보상 및 인출 현황',
        ukBalance: 'UK 잔액',
        ukPrice: 'UK 가격',
        myLevel: '내 레벨',
        activeStakes: '내 예측',
        predictions: '개 예측',
        teamPV: '팀 PV',
        fromInitial: '$0.01 대비',
        quickActions: '빠른 작업',
        predStaking: '예측 스테이킹',
        predDesc: '10x / 30x / 100x 목표',
        nodeManage: '노드 관리',
        nodeDesc: '600U · 1000 UK 보상',
        community: '커뮤니티',
        communityDesc: 'V1–V7 레벨 보상',
        todayRewards: "오늘의 보상",
        noRewards: '오늘 획득한 보상이 없습니다',
        recentTx: '최근 거래',
        virtualLedger: '가상 원장',
        withdraw: '지갑으로 UK 수령',
        withdrawType: '수령 유형',
        withdrawType1: '노드 UK 출시',
        withdrawType2: '유동성 보상',
        withdrawType3: '커뮤니티 보상',
        withdrawType4: '노드 배당',
        amount: '수량 (UK)',
        enterAmount: '수량 입력',
        minWithdraw: '최소 100 UK',
        available: '사용 가능',
        fee: '수수료 (1%)',
        youReceive: '받는 금액',
        status: '상태',
        pendingReview: '체인 요청 중',
        requestWithdraw: '인출 요청',
        withdrawSubmitted: '인출 요청이 제출되었습니다. 체인에서 처리 중입니다.',
        withdrawHistory: '인출 내역',
        noWithdraws: '인출 내역이 없습니다',
        statusPending: '체인 요청 중',
        statusApproved: '승인됨',
        statusDone: '완료됨',
        statusRejected: '거부됨',
        liquidityReward: '유동성 보상',
        communityReward: '커뮤니티 보상',
        nodeDividend: '노드 배당',
        totalRewards: '총 보상',
        pending: '대기 중',
    },

    prediction: {
        saleCountdown: '예측 구매 카운트다운',
        saleStartTime: '구매 시작 시간: 2026년 4월 25일 20:00 (베이징 시간)',
        fromNode: '노드 기여',
        fromPrediction: '예측 기여',
        rangeHint: '금액 범위: 100-1000 USDT',
        soldTime: '판매 시간',
        soldPrice: '판매 가격',
        soldUK: '판매 UK',
        receivedUSDT: '획득 USDT',
        soldTx: '판매 TX',
        txHash: 'TX 해시',
        approvingUSDT: "USDT 승인 중",
        joiningOnChain: "체인 참여 중",
        notifyingBackend: "완료",
        activeStakers: "활성 스테이커",
        participants: "참가자",
        priceTrend: 'UK 가격 추세',
        title: '예측',
        subtitle: '가격 목표로 예측하세요. 목표 달성 시 자동 강제 매도됩니다.',
        networkPV: '네트워크 예측 가치',
        currentPrice: '현재 가격',
        priceMultiple: '가격 배수',
        myPV: '내 예측 가치',
        newStake: '새 예측',
        principal: '원금 (USDT) · 100–1000',
        enterAmount: '금액 입력 (100–1000 USDT)',
        range: '범위',
        targetMultiple: '목표 배수',
        fundAllocation: '자금 할당 미리보기',
        liquidityPool: '유동성 풀 (40%)',
        incentivePool: '인센티브 풀 (60%)',
        predValue: '예측 가치',
        estUKBought: '예상 UK 구매량',
        paymentTx: '결제 TX 해시',
        txHint: '예측 계약으로 USDT 전송 후 TX 해시 붙여넣기',
        stakeBtn: '${amount} USDT 스테이킹',
        forceSellNote: '{multiple}x 가격 목표 도달 시 자동 강제 매도 실행',
        myStakes: '내 예측',
        active: '활성',
        noStakes: '아직 활성 스테이킹이 없습니다',
        staking: '스테이킹 중',
        forceSold: '강제 매도 완료',
        staked: '스테이킹됨',
        stakeSuccess: '스테이킹이 성공적으로 생성되었습니다!',
        conservative: '보수형',
        moderate: '안정형',
        aggressive: '공격형',
    },

    nodes: {
        saleCountdown: '판매 카운트다운',
        days: '일',
        hours: '시간',
        minutes: '분',
        seconds: '초',
        saleStartTime: '판매 시작: 2026년 3월 13일 12:09 (UTC+8)',
        title: '노드 관리',
        subtitle: '네트워크 노드를 구매 및 관리하여 UK 토큰 배당금을 획득하세요',
        myNodes: '내 노드 UK',
        max: '최대',
        totalAlloc: '총 할당 UK',
        totalReleased: '총 출시됨',
        claimable: '수령 가능',
        purchaseNode: '노드 구매',
        purchaseDesc: '노드 홀더가 되어 지속적인 UK 배당 보상을 받으세요',
        nodePrice: '노드 가격',
        yourUsdtBalance: '내 USDT 잔액',
        insufficient: '잔액 부족',
        buyCount: '수량',
        totalCost: '총 비용',
        purchaseTx: "구매 TX",
        benefit1: 'UK 토큰 배당 참여',
        benefit2: '최대 혜택 누리기',
        benefit3: '60 예측 가치 지급',
        benefit4: '얼리어답터를 위한 최저 UK 가격',
        benefit5: '독점 NFT 생성',
        benefit6: '장기 보유 보상',
        milestone: '노드는 최대 혜택을 누리며 60 예측 가치를 받습니다. 얼리어답터는 최저 UK 가격을 누립니다.',

        purchaseSuccess: '{count}개 노드 구매 성공!',
        purchaseFailed: '구매 실패, 다시 시도해주세요',
        userCancelled: '사용자가 거래를 취소했습니다',
        insufficientUsdt: 'USDT 잔액이 부족합니다',
        buyStopped: '구매 중지됨',
        connectFirst: '지갑 연결 필요',
        connectHint: '노드 구매를 위해 지갑을 연결하세요',
        purchaseBtnLabel: '노드 구매 ({cost} USDT)',
        txHash: '거래 해시',
        step1: '확인',
        step2: 'USDT 승인',
        step3: '체인 확인',
        step4: '데이터 동기화',
        myNodeList: '내 노드 목록',
        noNodes: '노드 없음',
        noNodesDesc: '노드를 구매하면 여기에 세부 정보가 표시됩니다',
        active: '활성',
        inactive: '비활성',
        releases: '회 출시',
        allocated: '할당됨',
        released: '출시됨',
        onChainNodes: '온체인 노드',
        onChainClaimed: '온체인 수령',
        claimBtn: '수령',
        claimFailed: '수령 실패',
        releaseRules: '출시 규칙',
        rule1Title: '월간 출시 + 가격 가속',
        rule1Desc: '30일마다 10% 출시, 또는 가격 10배 상승 시 10% 조기 출시, 100배에서 완전 출시',
        rule2Title: '성장하는 보상',
        rule2Desc: '플랫폼 거래량 증가에 따라 배당 풀이 확장되고 보상이 증가합니다',
        rule3Title: '즉시 수령 + NFT',
        rule3Desc: '출시 후 언제든지 수령 가능합니다. 각 노드는 고유한 NFT 인증서를 생성합니다',

        alreadyNode: '이 주소는 이미 노드를 보유하고 있습니다',
    },

    game: {
      gameOpen: "게임 오픈",
      openTime: "5월 27일 20:41 (UTC+8)",
      gameDescription: "게임이 정식 오픈되었습니다! 지금 바로 보석 여행을 시작하세요!",
      enterGame: "보석 여행",
      countdown: "게임 오픈까지 남은 시간:",
      hours: "시간",
      minutes: "분",
      seconds: "초",
      notOpenYet: "아직 게임이 오픈되지 않았습니다. 잠시만 기다려주세요!"
    },

    community: {
        communityNodes: '커뮤니티 노드',
        communityNodesDesc: '커뮤니티 내 총 노드 수',
        teamTotalPV: '팀 총 PV',
        todayNewPV: "오늘의 신규 PV",
        inviteQR: '초대 QR코드',
        members: '명',
        title: '커뮤니티',
        subtitle: '팀을 구축하고 일일 인센티브 풀에서 레벨 기반 보상을 획득하세요.',
        myLevel: '내 레벨',
        noLevel: '레벨 없음',
        teamPV: '팀 PV',
        directMembers: '직접 추천 회원',
        totalTeam: '전체 팀',
        inviteCode: '내 초대 코드',
        copyLink: '링크 복사',
        levelReqs: '레벨 요구사항',
        level: '레벨',
        minTeamPV: '최소 팀 PV',
        stake10x: '10x+ 스테이크',
        estDaily: '예상 일일 %',
        status: '상태',
        reached: '달성함',
        inProgress: '진행 중',
        queryTeam: '팀 성과 조회',
        queryAddr: '지갑 주소를 입력하여 조회...',
        address: '주소',
        totalMembers: '총 멤버',
        myDirectLines: '내 직속 회선',
        directLines: '직속 회선',
        noLines: '직속 추천인이 없습니다',
        subsidyProgress: '커뮤니티 보조금 진행 상황',
        subsidy20: '20 노드 이정표',
        subsidy40: '40 노드 이정표',
        apply: '보조금 신청',
        needMore: '{n}개 노드 더 필요',
        confirmApply: '{n} 노드 커뮤니티 보조금을 신청하시겠습니까?',
        applySuccess: '보조금 신청이 성공적으로 제출되었습니다!',
    },

    swap: {
        buyDisabled: '구매 비활성화됨',
        buyNotOpen: '구매 거래가 아직 열리지 않았습니다',
        buyNotOpenDesc: '구매 기능이 현재 비활성화되었습니다. 공식 발표를 기다려주세요.',
        slippageTooLow: '슬리피지가 너무 낮아 거래가 실패할 수 있습니다',
        slippageTooHigh: '슬리피지가 너무 높습니다. 주의하세요',
        title: '스왑',
        subtitle: 'PancakeSwap V2를 통한 USDT ↔ UK 거래',
        ukPrice: 'UK 가격',
        priceMultiple: '가격 배수',
        burned: '총 소각량',
        circulating: '유통량',
        trade: '거래',
        buy: '구매',
        sell: '판매',
        payUsdt: '지불 (USDT)',
        payUk: '지불 (UK)',
        receiveUk: '수령 (UK)',
        receiveUsdt: '수령 (USDT)',
        balance: '잔액',
        autoCalc: '자동 계산',
        estimating: '추정 중',
        slippage: '슬리피지',
        breakdown: '분배',
        slippageBreakdown: '소각 10% · 생태 10% · 재단 5% · 노드 5%',
        buyUK: 'UK 구매',
        sellUK: 'UK 판매',
        connectWallet: '지갑 연결',
        walletNote: 'PancakeSwap을 통해 온체인 스왑을 실행하려면 지갑을 연결하세요',
        swapSuccess: '스왑 성공! 거래가 확인되었습니다.',
        swapFailed: '스왑 실패, 다시 시도해주세요.',
        viewTx: 'BscScan에서 보기',
        tokenInfo: '토큰 정보',
        name: '이름',
        totalSupply: '총 공급량',
        initialPrice: '초기 가격',
        targetDestroy: '목표 소각량',
        network: '네트워크',
        dex: 'DEX',
        contracts: '계약 주소',
        nodeContract: '노드 계약',
        predContract: '예측 계약',
        slippageDetail: '슬리피지 분배 (30%)',
        burn: '소각 및 환류',
        eco: '생태 풀',
        foundation: '생태계',
        node: '노드 배당',
        slippageNote: '모든 판매에는 30% 슬리피지가 적용됩니다. 소각, 생태계, 재단, 노드 홀더에게 실시간으로 분배됩니다.',
        livePrice: '실시간 가격',
        multiple: '배수',
        pool: '풀',
        youPay: '지불',
        youReceive: '수령',
        estimating2: '추정 중...',
        viaPancake: 'PancakeSwap 경유',
        rate: '환율',
        route: '경로',
        minReceived: '최소 수령액',
        priceImpact: '가격 영향',
        connectFirst: '지갑 연결 필요',
        enterAmount: '금액 입력',
        processing: '처리 중...',
        txSuccess: '✅ 거래 성공!',
        powered: 'PancakeSwap V2 기반 · 탈중앙화 · 온체인',
        poolInfo: '유동성 풀 정보',
        ukReserve: 'UK 보유량',
        usdtReserve: 'USDT 보유량',
        pancakePair: 'PancakeSwap 페어',
        priceChart: '가격 차트 (24시간)',
        noChartData: '데이터 부족 · 거래 시작 후 더 많은 차트 데이터가 표시됩니다',
    },

    txType: {
        prediction_reward: '예측 보상',
        node_release: '노드 UK 출시',
        community_reward: '커뮤니티 보상',
        node_dividend: '노드 배당',
        whitelist_stake: '관리자 스테이킹',
        force_sell_return: '강제 매도 반환',
        withdraw_debit: '인출',
        withdraw_refund: '인출 환불',
        burn_virtual: '가상 소각',
        swap_virtual: '스왑',
    },

    error: {
        networkFailed: '네트워크 요청 실패',
        tokenExpired: '세션이 만료되었습니다. 다시 연결해주세요',
        insufficientBalance: '잔액 부족',
        minAmount: '최소 금액은 {min}입니다',
        maxAmount: '최대 금액은 {max}입니다',
        invalidAddress: '잘못된 지갑 주소',
        txFailed: '거래 실패',
        txRejected: '사용자가 거래를 거부했습니다',
        unknown: '알 수 없는 오류, 다시 시도해주세요',
    },
},
  en: {
    common: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      close: 'Close',
      loading: 'Loading...',
      processing: 'Processing...',
      success: 'Success',
      failed: 'Failed',
      retry: 'Retry',
      copy: 'Copy',
      copied: 'Copied!',
      refresh: 'Refresh',
      viewAll: 'View All',
      noData: 'No data yet',
      submit: 'Submit',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      search: 'Search',
      query: 'Query',
      comingSoon: 'Coming Soon',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
    },

    nav: {
      home: 'Home',
      dashboard: 'PlayerRound',
      tai: 'Ecosystem',
      prediction: 'Predict',
      nodes: 'Nodes',
      community: 'Community',
      swap: 'Swap',
      admin: 'Admin',
    },
    referrer: {
      title: 'Enter Referrer Address',
      subtitle: 'Please enter your referrer wallet address',
      address: 'Referrer Address',
      placeholder: 'Enter referrer wallet address (0x...)',
      hint: 'Please enter a valid Ethereum address',
      confirm: 'Confirm',
      required: 'Referrer Required',
      description: 'A valid referrer address is required to register',
      errorEmpty: 'Referrer address cannot be empty',
      errorInvalid: 'Invalid address format',
      errorZero: 'Invalid address: cannot be zero address',
    },

    wallet: {
      referrerAddress: 'Referrer Address',
      enterReferrer: 'Enter referrer wallet address',
      referrerRequired: 'Referrer address is required',
      invalidAddress: 'Invalid address format',
      connect: 'Connect Wallet',
      disconnect: 'Disconnect',
      connecting: 'Connecting...',
      connected: 'Connected',
      title: 'Connect Wallet',
      subtitle: 'Choose your Web3 wallet to continue',
      detected: 'Detected · Ready',
      notInstalled: 'Not installed',
      secure: 'Secure & Non-custodial',
      terms: 'By connecting you verify wallet ownership via signature. Your private key is never shared.',
      rejected: 'Connection rejected by user',
      signRequired: 'Please sign the message to verify wallet ownership',
      networkError: 'Please switch to BSC network and try again',
      failed: 'Connection failed, please try again',
      noWallet: 'No wallet detected. Please install a Web3 wallet.',
      installPrompt: 'Install',
      switchNetwork: 'Switch to BSC',
      ready: 'Ready',
    },

    home: {
      tagline: 'Live on BSC',
      heroTitle1: 'User Keep',
      heroTitle2: 'UK Token',
      heroDesc: 'Stake · Predict · Earn · Grow\nPowered by NEXA PAY Global Payment Network',
      connectStart: 'Connect Wallet to Start',
      goDashboard: 'Go to Player Round',
      tradeUK: 'Trade UK',
      currentPrice: 'Current Price',
      priceMultiple: 'Price Multiple',
      totalSupply: 'Total Supply',
      activeNodes: 'Active Nodes',
      feature1Title: 'Prediction Staking',
      feature1Desc: 'Stake 100–1000 USDT with 10x/30x/100x targets. Auto force-sell at target price.',
      feature2Title: 'Community Rewards',
      feature2Desc: 'Build your team and earn V1–V7 community incentives from the reward pool daily.',
      feature3Title: 'Node Privileges',
      feature3Desc: '600 USDT for a node. Get 1000 UK, swap slippage dividends, DAO voting rights.',
    },

    dashboard: {
      withdrawSuccess: "withdraw success",
      insufficientBalance: "insufficient balance",
      max: "max",
      rewardDetails: "Reward Details",
      noRewards: "No reward records yet",
      nodeReward: "Node Rewards",
      nodeRewardDesc: "Released node UK rewards",
      liquidityRewardDesc: "Daily liquidity pool rewards (10%)",
      communityRewardDesc: "Community level rewards (40%)",
      nodeDividendDesc: "Node dividend from prediction mechanism (5%) + Buy Or Sell mechanism (5%)",
      claimed: "Claimed",
      total: "Total",
      view: 'View',
      title: 'PlayerRound',
      execute: 'Execute',
      subtitle: 'Overview of your assets, rewards and withdrawals',
      ukBalance: 'UK Balance',
      ukPrice: 'UK Price',
      myLevel: 'My Level',
      activeStakes: 'My Predictions',
      predictions: 'predictions',
      teamPV: 'Team PV',
      fromInitial: 'from $0.01',
      quickActions: 'Quick Actions',
      predStaking: 'Prediction Staking',
      predDesc: '10x / 30x / 100x targets',
      nodeManage: 'Node Management',
      nodeDesc: '600U · 1000 UK rewards',
      community: 'Community',
      communityDesc: 'V1–V7 level rewards',
      todayRewards: "Today's Rewards",
      noRewards: 'No rewards today yet',
      recentTx: 'Recent Transactions',
      virtualLedger: 'Virtual Ledger',
      // 提现
      withdraw: 'Get UK to Wallet',
      withdrawType: 'Get Type',
      withdrawType1: 'Node UK Release',
      withdrawType2: 'Liquidity Reward',
      withdrawType3: 'Community Reward',
      withdrawType4: 'Node Dividend',
      amount: 'Amount (UK)',
      enterAmount: 'Enter amount',
      minWithdraw: 'Min 100 UK',
      available: 'Available',
      fee: 'Fee (1%)',
      youReceive: 'You receive',
      status: 'Status',
      pendingReview: 'OnChaining',
      requestWithdraw: 'Request Withdraw',
      withdrawSubmitted: 'Withdraw request submitted, pending onchain.',
      withdrawHistory: 'Withdraw History',
      noWithdraws: 'No withdrawal history',
      // 状态标签
      statusPending: 'OnChaining',
      statusApproved: 'Passed',
      statusDone: 'Completed',
      statusRejected: 'Rejected',
      // 奖励汇总
      liquidityReward: 'Liquidity Reward',
      communityReward: 'Community Reward',
      nodeDividend: 'Node Dividend',
      totalRewards: 'Total Rewards',
      pending: 'Pending',
    },

    prediction: {
      saleCountdown: 'Prediction Purchase Countdown',
      saleStartTime: 'Purchase start time: April 25, 2026 20:00 (Beijing time)',
      fromNode: 'From Node',
      fromPrediction: 'From Prediction',
      rangeHint: 'Amount range: 100-1000 USDT',
      soldTime: 'Sold Time',
      soldPrice: 'Sold Price',
      soldUK: 'UK Sold',
      receivedUSDT: 'USDT Received',
      soldTx: 'Sold TX',
      txHash: 'TX Hash',
      approvingUSDT: "Approving USDT",
      joiningOnChain: "Joining On-Chain",
      notifyingBackend: "Complete",
      activeStakers: "Active Stakers",
      participants: "Participants",
      priceTrend: 'UK Price Trend',
      title: 'Prediction',
      subtitle: 'Prediction with price targets. Auto force-sell when target is reached.',
      networkPV: 'Network Pred. Value',
      currentPrice: 'Current Price',
      priceMultiple: 'Price Multiple',
      myPV: 'My Pred. Value',
      newStake: 'New Prediction',
      principal: 'Principal (USDT) · 100–1000',
      enterAmount: 'Enter amount (100–1000 USDT)',
      range: 'Range',
      targetMultiple: 'Target Multiple',
      fundAllocation: 'Fund Allocation Preview',
      liquidityPool: 'Liquidity Pool (40%)',
      incentivePool: 'Incentive Pool (60%)',
      predValue: 'Prediction Value',
      estUKBought: 'Est. UK Bought',
      paymentTx: 'Payment TX Hash',
      txHint: 'Paste the TX hash after sending USDT to the prediction contract',
      stakeBtn: 'Stake ${amount} USDT',
      forceSellNote: 'Force-sell triggers automatically at {multiple}x price target',
      myStakes: 'My Predictions',
      active: 'active',
      noStakes: 'No active stakes yet',
      staking: 'Staking',
      forceSold: 'Force Sold',
      staked: 'Staked',
      stakeSuccess: 'Stake created successfully!',
      conservative: 'Conservative',
      moderate: 'Moderate',
      aggressive: 'Aggressive',
    },

    nodes: {
      saleCountdown: 'Sale Countdown',
      days: 'Days',
      hours: 'Hours', 
      minutes: 'Minutes',
      seconds: 'Seconds',
      saleStartTime: 'Sale starts: March 13, 2026 12:09 (UTC+8)',
      title: 'Node Management',
      subtitle: 'Purchase and manage your network nodes to earn UK token dividends',
      myNodes: 'My Node UK',
      max: 'max',
      totalAlloc: 'Total Allocated',
      totalReleased: 'Total Released',
      claimable: 'Claimable',
      purchaseNode: 'Purchase Node',
      purchaseDesc: 'Become a node holder and earn continuous UK dividend rewards',
      nodePrice: 'Node Price',
      yourUsdtBalance: 'My USDT Balance',
      insufficient: 'Insufficient',
      buyCount: 'Quantity',
      totalCost: 'Total Cost',
      purchaseTx: "Purchase Tx",
      benefit1: 'Participate in UK Token Dividends',
      benefit2: 'Enjoy Maximum Benefits',
      benefit3: 'Receive 60 Prediction Value',
      benefit4: 'Early Adopters Get Lowest UK Price',
      benefit5: 'Generate Exclusive NFT',
      benefit6: 'Long-term Holding Rewards',
      milestone: 'Nodes enjoy maximum benefits and receive 60 prediction value. Early adopters get the lowest UK price.',

      purchaseSuccess: 'Successfully purchased {count} node(s)!',
      purchaseFailed: 'Purchase failed, please try again',
      userCancelled: 'Transaction cancelled by user',
      insufficientUsdt: 'Insufficient USDT balance',
      buyStopped: 'BuyStopped',
      connectFirst: 'Connect Wallet First',
      connectHint: 'Connect your wallet to purchase nodes',
      purchaseBtnLabel: 'Purchase Node ({cost} USDT)',
      txHash: 'Transaction Hash',
      step1: 'Verify',
      step2: 'Approve USDT',
      step3: 'On-chain Confirm',
      step4: 'Sync Data',
      myNodeList: 'My Node List',
      noNodes: 'No Nodes Yet',
      noNodesDesc: 'Purchase a node to view details here',
      active: 'Active',
      inactive: 'Inactive',
      releases: 'releases',
      allocated: 'Allocated',
      released: 'Released',
      onChainNodes: 'On-chain Nodes',
      onChainClaimed: 'On-chain Claimed',
      claimBtn: 'Claim',
      claimFailed: 'Claim failed',
      releaseRules: 'Release Rules',
      rule1Title: 'Monthly Release + Price Acceleration',
      rule1Desc: 'Release 10% every 30 days, or accelerate 10% per 10x price increase, fully released at 100x',
      rule2Title: 'Growing Rewards',
      rule2Desc: 'As platform volume grows, the dividend pool expands and rewards increase',
      rule3Title: 'Instant Claim + NFT',
      rule3Desc: 'Claim anytime after release. Each node generates a unique NFT certificate',

      alreadyNode: 'This address already owns a node',
    },

    community: {
      communityNodes: 'Community Nodes',
      communityNodesDesc: 'Total nodes in your community',
      teamTotalPV: 'Team Total PV',
      todayNewPV: "Today's New PV",
      inviteQR: 'invite QRCode',
      members: 'members',
      title: 'Community',
      subtitle: 'Build your team and earn level-based rewards from the daily incentive pool.',
      myLevel: 'My Level',
      noLevel: 'No Level',
      teamPV: 'Team PV',
      directMembers: 'Direct Members',
      totalTeam: 'Total Team',
      inviteCode: 'My Invite Code',
      copyLink: 'Copy Link',
      levelReqs: 'Level Requirements',
      level: 'Level',
      minTeamPV: 'Min Team PV',
      stake10x: '10x+ Stake',
      estDaily: 'Est. Daily %',
      status: 'Status',
      reached: 'Reached',
      inProgress: 'In Progress',
      queryTeam: 'Query Team Performance',
      queryAddr: 'Enter wallet address to query...',
      address: 'Address',
      totalMembers: 'Total Members',
      myDirectLines: 'My Direct Lines',
      directLines: 'Direct Lines',
      noLines: 'No direct referrals yet',
      subsidyProgress: 'Community Subsidy Progress',
      subsidy20: '20 Nodes Milestone',
      subsidy40: '40 Nodes Milestone',
      apply: 'Apply for Subsidy',
      needMore: 'Need {n} more nodes',
      confirmApply: 'Apply for the {n}-node community subsidy?',
      applySuccess: 'Subsidy application submitted successfully!',
    },

    swap: {
      buyDisabled: 'Buy Disabled',
      buyNotOpen: 'Buy trading not open yet',
      buyNotOpenDesc: 'Buy function is currently disabled. Please wait for official announcement.',
      slippageTooLow: 'Slippage too low, may cause transaction failure',
      slippageTooHigh: 'Slippage too high, please be cautious',
      title: 'Swap',
      subtitle: 'Trade USDT ↔ UK via PancakeSwap V2',
      ukPrice: 'UK Price',
      priceMultiple: 'Price Multiple',
      burned: 'Total Burned',
      circulating: 'Circulating',
      trade: 'Trade',
      buy: 'Buy',
      sell: 'Sell',
      payUsdt: 'You Pay (USDT)',
      payUk: 'You Pay (UK)',
      receiveUk: 'You Receive (UK)',
      receiveUsdt: 'You Receive (USDT)',
      balance: 'Balance',
      autoCalc: 'Auto-calculated',
      estimating: 'Estimating',
      slippage: 'Slippage',
      breakdown: 'Distribution',
      slippageBreakdown: 'Burn 10% · Eco 10% · Foundation 5% · Node 5%',
      buyUK: 'Buy UK',
      sellUK: 'Sell UK',
      connectWallet: 'Connect Wallet',
      walletNote: 'Connect your wallet to execute on-chain swaps via PancakeSwap',
      swapSuccess: 'Swap successful! Transaction confirmed.',
      swapFailed: 'Swap failed, please try again.',
      viewTx: 'View on BscScan',
      tokenInfo: 'Token Info',
      name: 'Name',
      totalSupply: 'Total Supply',
      initialPrice: 'Initial Price',
      targetDestroy: 'Target Destroyed',
      network: 'Network',
      dex: 'DEX',
      contracts: 'Contract Addresses',
      nodeContract: 'Node Contract',
      predContract: 'Prediction Contract',
      slippageDetail: 'Slippage Distribution (30%)',
      burn: 'Burn And Back',
      eco: 'Eco Pool',
      foundation: 'Eco',
      node: 'Node Dividend',
      slippageNote: 'All sells carry 30% slippage. Distribution goes to burn, ecosystem, foundation, and node holders in real-time.',
      livePrice: 'Live Price',
      multiple: 'Multiple',
      pool: 'Pool',
      youPay: 'You Pay',
      youReceive: 'You Receive',
      estimating2: 'Estimating...',
      viaPancake: 'Via PancakeSwap',
      rate: 'Rate',
      route: 'Route',
      minReceived: 'Min Received',
      priceImpact: 'Price Impact',
      connectFirst: 'Connect Wallet First',
      enterAmount: 'Enter Amount',
      processing: 'Processing...',
      txSuccess: '✅ Transaction Successful!',
      powered: 'Powered by PancakeSwap V2 · Decentralized · On-chain',
      poolInfo: 'Liquidity Pool Info',
      ukReserve: 'UK Reserve',
      usdtReserve: 'USDT Reserve',
      pancakePair: 'PancakeSwap Pair',
      priceChart: 'Price Chart (24h)',
      noChartData: 'Insufficient data · More chart data after trading begins',
    },

    game: {
      gameOpen: "Game Open",
      openTime: "May 27, 20:41 (UTC+8)",
      gameDescription: "Game is now open! Start your gem journey now!",
      enterGame: "Gem Journey",
      countdown: "Time until game opens:",
      hours: "h",
      minutes: "m",
      seconds: "s",
      notOpenYet: "Game is not open yet. Please wait!"
    },
    txType: {
      prediction_reward: 'Prediction Reward',
      node_release: 'Node UK Release',
      community_reward: 'Community Reward',
      node_dividend: 'Node Dividend',
      whitelist_stake: 'Admin Stake',
      force_sell_return: 'Force Sell Return',
      withdraw_debit: 'Withdraw',
      withdraw_refund: 'Withdraw Refund',
      burn_virtual: 'Virtual Burn',
      swap_virtual: 'Swap',
    },

    error: {
      networkFailed: 'Network request failed',
      tokenExpired: 'Session expired, please reconnect',
      insufficientBalance: 'Insufficient balance',
      minAmount: 'Minimum amount is {min}',
      maxAmount: 'Maximum amount is {max}',
      invalidAddress: 'Invalid wallet address',
      txFailed: 'Transaction failed',
      txRejected: 'Transaction rejected by user',
      unknown: 'Unknown error, please try again',
    },
  },

  // ============================================================
  zh: {
    common: {
      comingSoon: '即将开放',
      confirm: '确认',
      cancel: '取消',
      close: '关闭',
      loading: '加载中...',
      processing: '处理中...',
      success: '成功',
      failed: '失败',
      retry: '重试',
      copy: '复制',
      copied: '已复制！',
      refresh: '刷新',
      viewAll: '查看全部',
      noData: '暂无数据',
      submit: '提交',
      save: '保存',
      edit: '编辑',
      delete: '删除',
      search: '搜索',
      query: '查询',
      back: '返回',
      next: '下一步',
      yes: '是',
      no: '否',
    },

    nav: {
      home: '首页',
      dashboard: '玩家面板',
      tai: '生态',
      prediction: '预测',
      nodes: '节点',
      community: '社区',
      swap: '兑换',
      admin: '管理',
    },
    referrer: {
      title: '输入上级地址',
      subtitle: '请输入您的上级钱包地址',
      address: '上级地址',
      placeholder: '请输入上级钱包地址 (0x...)',
      hint: '请输入有效的以太坊地址',
      confirm: '确认',
      required: '需要上级地址',
      description: '注册需要有效的上级地址',
      errorEmpty: '上级地址不能为空',
      errorInvalid: '地址格式不正确',
      errorZero: '无效地址：不能是零地址',
    },

    wallet: {
      referrerAddress: '上级地址',
      enterReferrer: '请输入上级钱包地址',
      referrerRequired: '请输入上级地址',
      invalidAddress: '地址格式不正确',
      connect: '连接钱包',
      disconnect: '断开连接',
      connecting: '连接中...',
      connected: '已连接',
      title: '连接钱包',
      subtitle: '选择您的 Web3 钱包继续',
      detected: '已检测 · 可连接',
      notInstalled: '未安装',
      secure: '安全 · 非托管',
      terms: '连接钱包即通过签名验证所有权，您的私钥不会被共享。',
      rejected: '用户取消了连接请求',
      signRequired: '请签名以验证钱包所有权',
      networkError: '请切换到 BSC 网络后重试',
      failed: '连接失败，请重试',
      noWallet: '未检测到钱包，请安装 Web3 钱包',
      installPrompt: '安装',
      switchNetwork: '切换到 BSC',
      ready: '就绪',
    },

    

    home: {
      tagline: 'BSC 链上运行',
      heroTitle1: 'User Keep',
      heroTitle2: 'UK 代币',
      heroDesc: '质押 · 预测 · 赚取 · 成长\n由 NEXA PAY 全球支付网络驱动',
      connectStart: '连接钱包开始',
      goDashboard: '进入玩家面板',
      tradeUK: '交易 UK',
      currentPrice: '当前价格',
      priceMultiple: '价格倍数',
      totalSupply: '总供应量',
      activeNodes: '活跃节点',
      feature1Title: '预测质押',
      feature1Desc: '质押 100–1000 USDT，设定 10x/30x/100x 目标，达到目标价格自动强制卖出。',
      feature2Title: '社区奖励',
      feature2Desc: '建立您的团队，每日从激励池获得 V1–V7 社区奖励。',
      feature3Title: '节点特权',
      feature3Desc: '600 USDT 购买节点，获得 1000 UK、滑点分红、DAO 投票权。',
    },

    dashboard: {
      withdrawSuccess: "提现成功",
      insufficientBalance: "余额不足",
      max: "最大",
      rewardDetails: "奖励明细",
      noRewards: "暂无奖励记录",
      nodeReward: "节点奖励",
      nodeRewardDesc: "节点UK释放奖励",
      liquidityRewardDesc: "每日流动性池奖励 (10%)",
      communityRewardDesc: "社区等级奖励 (40%)",
      nodeDividendDesc: "预测机制节点分红 (5%) + 买卖滑点节点分红 (5%)",
      claimed: "已领取",
      total: "总计",
      view: '查看',
      title: '玩家面板',
      subtitle: '资产、奖励和提现总览',
      ukBalance: 'UK 余额',
      ukPrice: 'UK 价格',
      myLevel: '我的等级',
      activeStakes: '我的预测',
      predictions: '个预测',
      teamPV: '小区预测值',
      fromInitial: '相对 $0.01',
      quickActions: '快速操作',
      predStaking: '预测质押',
      predDesc: '10x / 30x / 100x 目标',
      nodeManage: '节点管理',
      nodeDesc: '600U · 1000 UK 奖励',
      community: '社区',
      communityDesc: 'V1–V7 等级奖励',
      todayRewards: '今日奖励',
      noRewards: '今日暂无奖励',
      recentTx: '近期交易',
      virtualLedger: '虚拟账本',
      withdraw: '领取 UK 到钱包',
      withdrawType: '领取类型',
      withdrawType1: '节点 UK 释放',
      withdrawType2: '流动性奖励',
      withdrawType3: '社区奖励',
      withdrawType4: '节点分红',
      amount: '数量（UK）',
      enterAmount: '输入数量',
      minWithdraw: '最少 100 UK',
      available: '可用',
      execute: '执行',
      fee: '手续费（1%）',
      youReceive: '您将收到',
      status: '状态',
      pendingReview: '链上请求中',
      requestWithdraw: '申请执行',
      withdrawSubmitted: '已提交，等待链上执行',
      withdrawHistory: '提现记录',
      noWithdraws: '暂无提现记录',
      statusPending: '链上请求中',
      statusApproved: '已通过',
      statusDone: '已完成',
      statusRejected: '已拒绝',
      liquidityReward: '流动性奖励',
      communityReward: '社区奖励',
      nodeDividend: '节点分红',
      totalRewards: '总奖励',
      pending: '待领取',
    },

    prediction: {
      saleCountdown: '预测购买倒计时',
      saleStartTime: '购买开始时间：2026年4月25日 21:00 (北京时间)',
      fromNode: '节点贡献',
      fromPrediction: '预测贡献',
      rangeHint: '金额范围：100-1000 USDT',
      soldTime: '卖出时间',
      soldPrice: '卖出价格',
      soldUK: '卖出UK',
      receivedUSDT: '获得USDT',
      soldTx: '卖出交易',
      txHash: '交易哈希',
      approvingUSDT: "授权 USDT",
      joiningOnChain: "链上加入",
      notifyingBackend: "完成",
      activeStakers: "有效预测人数",
      participants: "参与者",
      priceTrend: 'UK价格趋势',
      title: '预测',
      subtitle: '设定价格目标进行预测，达到目标自动强制卖出。',
      networkPV: '全网预测值',
      currentPrice: '当前价格',
      priceMultiple: '价格倍数',
      myPV: '我的预测值',
      newStake: '新建预测',
      principal: '本金（USDT）· 100–1000',
      enterAmount: '输入金额（100–1000 USDT）',
      range: '范围',
      targetMultiple: '目标倍数',
      fundAllocation: '资金分配预览',
      liquidityPool: '流动性池（40%）',
      incentivePool: '激励池（60%）',
      predValue: '预测值',
      estUKBought: '预估购入 UK',
      paymentTx: '付款 TX 哈希',
      txHint: '向预测合约发送 USDT 后，粘贴 TX 哈希',
      stakeBtn: '质押 ${amount} USDT',
      forceSellNote: '达到 {multiple}x 目标价格时自动触发强制卖出',
      myStakes: '我的预测',
      active: '活跃',
      noStakes: '暂无活跃质押',
      staking: '质押中',
      forceSold: '已强制卖出',
      staked: '已质押',
      stakeSuccess: '质押创建成功！',
      conservative: '保守型',
      moderate: '稳健型',
      aggressive: '激进型',
    },

    nodes: {
      saleCountdown: '售卖倒计时',
      days: '天',
      hours: '时',
      minutes: '分',
      seconds: '秒',
      saleStartTime: '售卖开始时间：2026年3月13日 12:09 (北京时间)',
      title: '节点管理',
      subtitle: '购买并管理您的网络节点，参与UK代币分红',
      myNodes: '节点中的UK',
      max: '最多',
      totalAlloc: '总分配UK',
      totalReleased: '已释放UK',
      claimable: '可领取',
      purchaseNode: '购买节点',
      purchaseDesc: '成为节点持有者，获得持续UK分红收益',
      nodePrice: '节点价格',
      yourUsdtBalance: '我的USDT余额',
      insufficient: '余额不足',
      buyCount: '购买数量',
      totalCost: '合计费用',
      benefit1: '参与UK代币分红',
      benefit2: '享受最多权益',
      benefit3: '赠送60预测值',
      benefit4: '早期加入享受UK最低价格',
      benefit5: '生成专属NFT',
      benefit6: '长期持有奖励',
      milestone: '节点享受最多权益,并赠送60预测值,早期加入享受UK最低价格',
      purchaseSuccess: '成功购买 {count} 个节点！',
      purchaseFailed: '购买失败，请重试',
      userCancelled: '用户取消了交易',
      alreadyNode: '该地址已拥有节点',
      insufficientUsdt: 'USDT余额不足，请先充值',
      buyStopped: '停止售卖',
      connectFirst: '请先连接钱包',
      purchaseTx: '购买交易',
      connectHint: '连接钱包后即可购买节点',
      purchaseBtnLabel: '购买节点 ({cost} USDT)',
      txHash: '交易哈希',
      step1: '验证信息',
      step2: '授权USDT',
      step3: '链上确认',
      step4: '同步数据',
      myNodeList: '我的节点列表',
      noNodes: '暂无节点',
      noNodesDesc: '购买节点后即可在此查看详情',
      active: '活跃',
      inactive: '未激活',
      releases: '次释放',
      allocated: '分配',
      released: '已释放',
      onChainNodes: '链上节点数',
      onChainClaimed: '链上已领',
      claimBtn: '领取',
      claimFailed: '领取失败',
      releaseRules: '释放规则',
      rule1Title: '每月释放 + 价格加速',
      rule1Desc: '每30天释放10%,或每上涨10倍提前释放10%,100倍时释放完毕',
      rule2Title: '收益持续增长',
      rule2Desc: '随着平台交易量增长,节点分红池持续扩大,收益逐步提升',
      rule3Title: '即时领取 + NFT',
      rule3Desc: '释放后可随时领取,每个节点生成唯一NFT凭证',

    },

    community: {
      communityNodes: '社区节点数',
      communityNodesDesc: '您的社区内所有节点总数',
      teamTotalPV: '团队总预测值',
      todayNewPV: '今日新增预测值',
      inviteQR: '邀请二维码',
      members: '成员',
      title: '社区',
      subtitle: '建立您的团队，从每日激励池中获得基于等级的奖励。',
      myLevel: '我的社区等级',
      noLevel: '无等级',
      teamPV: '小区预测值',
      directMembers: '直推成员',
      totalTeam: '总团队',
      inviteCode: '我的邀请码',
      copyLink: '复制链接',
      levelReqs: '等级要求',
      level: '等级',
      minTeamPV: '最低小区 PV',
      stake10x: '10x+ 质押',
      estDaily: '预估日收益%',
      status: '状态',
      reached: '已达到',
      inProgress: '进行中',
      queryTeam: '查询团队业绩',
      queryAddr: '输入钱包地址查询...',
      address: '地址',
      totalMembers: '总成员',
      myDirectLines: '我的直推线',
      directLines: '直推线',
      noLines: '暂无直推成员',
      subsidyProgress: '社区补贴进度',
      subsidy20: '20 节点里程碑',
      subsidy40: '40 节点里程碑',
      apply: '申请补贴',
      needMore: '还需 {n} 个节点',
      confirmApply: '申请 {n} 节点社区补贴？',
      applySuccess: '补贴申请提交成功！',
    },
    game: {
      gameOpen: "游戏开放",
      openTime: "5月27日 20:41 (UTC+8)",
      gameDescription: "游戏已正式开放，立即开始您的宝石之旅！",
      enterGame: "宝石之旅",
      countdown: "距离游戏开放还有",
      hours: "小时",
      minutes: "分钟",
      seconds: "秒",
      notOpenYet: "游戏尚未开放，请耐心等待！"
    },

    swap: {
      buyDisabled: '买入已禁用',
      buyNotOpen: '买入交易暂未开放',
      buyNotOpenDesc: '买入功能当前已禁用，请等待官方公告。',
      slippageTooLow: '滑点过低，可能导致交易失败',
      slippageTooHigh: '滑点过高，请谨慎操作',
      title: '兑换',
      subtitle: '通过 PancakeSwap V2 交易 USDT ↔ UK',
      ukPrice: 'UK 价格',
      priceMultiple: '价格倍数',
      burned: '累计销毁',
      circulating: '流通量',
      trade: '交易',
      buy: '买入',
      sell: '卖出',
      payUsdt: '您支付（USDT）',
      payUk: '您支付（UK）',
      receiveUk: '您收到（UK）',
      receiveUsdt: '您收到（USDT）',
      balance: '余额',
      autoCalc: '自动计算',
      estimating: '估算中',
      slippage: '滑点',
      breakdown: '分配',
      slippageBreakdown: '销毁 10% · 生态 10% · 基金会 5% · 节点 5%',
      buyUK: '买入 UK',
      sellUK: '卖出 UK',
      connectWallet: '连接钱包',
      walletNote: '连接钱包以通过 PancakeSwap 执行链上兑换',
      swapSuccess: '兑换成功！交易已确认。',
      swapFailed: '兑换失败，请重试。',
      viewTx: '在 BscScan 查看',
      tokenInfo: '代币信息',
      name: '名称',
      totalSupply: '总供应量',
      initialPrice: '初始价格',
      targetDestroy: '目标销毁量',
      network: '网络',
      dex: '去中心化交易所',
      contracts: '合约地址',
      nodeContract: '节点合约',
      predContract: '预测合约',
      slippageDetail: '滑点分配（30%）',
      burn: '销毁并回流',
      eco: '生态池',
      foundation: '生态建设',
      node: '节点分红',
      slippageNote: '卖含 30% 滑点，实时分配至销毁、生态、基金会和节点持有者。',
      livePrice: '实时价格',
      multiple: '倍数',
      pool: '流动池',
      youPay: '您支付',
      youReceive: '您收到',
      estimating2: '估算中...',
      viaPancake: '通过 PancakeSwap',
      rate: '汇率',
      route: '路由',
      minReceived: '最少收到',
      priceImpact: '价格影响',
      connectFirst: '请先连接钱包',
      enterAmount: '输入金额',
      processing: '处理中...',
      txSuccess: '✅ 交易成功！',
      powered: '由 PancakeSwap V2 驱动 · 去中心化 · 链上',
      poolInfo: '流动性池信息',
      ukReserve: 'UK 储备',
      usdtReserve: 'USDT 储备',
      pancakePair: 'PancakeSwap 交易对',
      priceChart: '价格走势（24h）',
      noChartData: '数据不足 · 交易开始后将显示更多图表数据',
    },

    txType: {
      prediction_reward: '预测奖励',
      node_release: '节点 UK 释放',
      community_reward: '社区奖励',
      node_dividend: '节点分红',
      whitelist_stake: '管理员质押',
      force_sell_return: '强制卖出返还',
      withdraw_debit: '提现',
      withdraw_refund: '提现退款',
      burn_virtual: '虚拟销毁',
      swap_virtual: '兑换',
    },

    error: {
      networkFailed: '网络请求失败',
      tokenExpired: '登录已过期，请重新连接',
      insufficientBalance: '余额不足',
      minAmount: '最少 {min}',
      maxAmount: '最多 {max}',
      invalidAddress: '无效的钱包地址',
      txFailed: '交易失败',
      txRejected: '用户拒绝了交易',
      unknown: '未知错误，请重试',
    },
  }
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || (navigator.language.startsWith('zh') ? 'zh' : 'en'),
  fallbackLocale: 'en',
  messages,
})

export default i18n
